import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);

// DrawLab web must always serve the latest deployed bundle.
// The Chrome extension is the offline/local product; PWA app-shell caching on
// the website keeps resurrecting old Excalidraw UI after deploys.
void navigator.serviceWorker?.getRegistrations().then((registrations) => {
  registrations.forEach((registration) => registration.unregister());
});
void window.caches?.keys().then((keys) => {
  keys.forEach((key) => window.caches.delete(key));
});

root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
